import {Flex, Show} from "@chakra-ui/react";

export const mobileBottomNavStyle = {
  borderRadius: '0',
  height: '100%',
  width: 'calc(50% - 0.5px)',
  fontSize: '0.875rem',
};

export default function MobileBottomNav({children}){
  return <Show breakpoint="(max-width: 767px)">
      <Flex
        position="fixed"
        bottom="0"
        zIndex="overlay"
        width="100vw"
        borderTop="1px solid"
        borderTopColor="brand.100"
        height="2.75rem"
      >
        {children}
      </Flex>
    </Show>
    }